import { LOGGER } from '../../api/env'

let logger = () => {}
if (LOGGER === '1') {
  logger = console.log.bind(console) // eslint-disable-line
}

export { logger }
